

let vivusBaseWindowWidth = window.innerWidth <= 767 ? 375 : 1440;
let scale = vivusBaseWindowWidth / window.innerWidth;

// リサイズ時にも更新
window.addEventListener("resize", () => {
  vivusBaseWindowWidth = window.innerWidth <= 767 ? 375 : 1440;
  scale = vivusBaseWindowWidth / window.innerWidth;
});

// duration計算関数をexport
export function vivusAnimationDuration(num) {
  var d = Math.max(50, Math.round(num * scale));
  console.log(`duration: ${d} (scale: ${scale}, base: ${vivusBaseWindowWidth})`);
  return d;
}
